import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class OutingApiService {

  constructor(private http:HttpClient) { }

  getFamilyDetails(){
    const refId = localStorage.getItem("uniqueRefId")
    const headers = new HttpHeaders({ });
        return this.http.get(environment.parentReport + 'student/jwt/v2/outing/getFamilyDetails?encryptedStudentId='+refId, { headers });
  }

getFamilyPhoto(admNo: any, familyId: any): Observable<Blob> {
  const headers = new HttpHeaders({});
  return this.http.get(
    environment.parentReport + 'student/jwt/v2/outing/getFamilyMemberPhoto?admNo=' + admNo + "&familyId=" + familyId,
    { headers, responseType: 'blob' }
  );
}

  getOutingReasons(){
    const headers = new HttpHeaders({ });
        return this.http.get(environment.parentReport + 'student/jwt/v2/outing/getOutingReasons', { headers });
  }

  getFamilyRelations(){
    const headers = new HttpHeaders({ });
        return this.http.get(environment.parentReport + 'student/jwt/v2/outing/getFamilyRelations', { headers });
  }

  uploadFamilyImage(file: any, familyId: any, relation: any,admNo:any) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('familyId', familyId); 
    formData.append('relation', relation);
    formData.append('admNo', admNo);

    const headers = new HttpHeaders({
    });
    return this.http.post(environment.parentReport+"student/jwt/v2/outing/uploadFamilyMemberPhoto", formData, { headers })
  }

  saveStudentOutingDetails(payload: any) {
    const headers = new HttpHeaders({
    });
    return this.http.post(environment.parentReport + 'student/jwt/v2/outing/saveOutingDetails', payload, { headers })
  }

  saveStudentFamilygDetails(payload: any) {
    const headers = new HttpHeaders({
    });
    return this.http.post(environment.parentReport + 'student/jwt/v2/outing/saveStdFamilyDetails', payload, { headers })
  }

}
